module.exports = __webpack_public_path__ + "img/information-line.c9521a9f.svg";